import BaseErrorHandler from '@/apis/errorHandler/handler/BaseErrorHandler'
import  AlertTypeEnum from '@/apis/errorHandler/AlertTypeEnum'

export default class DefaultException extends BaseErrorHandler {
    protected Code: string = "Error";
    protected AlertType:AlertTypeEnum=AlertTypeEnum.ERROR;
    constructor(messageKey?: string, message?: string) {
        super(messageKey, message);
    }
    customizeAction(): void {
    }
}
